import { PrintService } from "./print/print.service";
import { ExpressIDCardPrintingRoutes } from "./ExpressIDCardPrinting-routes";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ExpressIDCardPrintingComponent, PrintComponent } from "./index";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StudentModule } from "../student/student.module";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { PersonSelectorModule } from "../personselector/personselector.module";

@NgModule({
	declarations: [ExpressIDCardPrintingComponent, PrintComponent],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		RouterModule,
		ConfirmDialogModule,
		DialogModule,
		PersonSelectorModule,
		StudentModule,
	],

	providers: [ConfirmationService, PrintService],
})
export class ExpressIDCardPrintingModule {}
